<template>
  <group-select-removable-checkbox
    v-if="removable && checkbox"
    class="zoox-component zoox-group-select"
    v-bind="$props"
    :style-attrs="styleAttrs"
    @change="onChange"
    @click:remove="onClickRemove"
  />
  <group-select-checkbox
    v-else-if="checkbox"
    v-bind="$props"
    class="zoox-component zoox-group-select"
    :style-attrs="styleAttrs"
    @change="onChange"
  />
  <group-select-removable
    v-else-if="removable"
    v-bind="$props"
    class="zoox-component zoox-group-select"
    :style-attrs="styleAttrs"
    @change="onChange"
    @click:remove="onClickRemove"
  />

  <group-select-removable
    v-else
    v-bind="$props"
    class="zoox-component zoox-group-select"
    :remove-icon="''"
    :style-attrs="styleAttrs"
    @change="onChange"
  ></group-select-removable>
</template>

<script>
import GroupSelectCheckbox from './_private/GroupSelectCheckbox'
import GroupSelectRemovable from './_private/GroupSelectRemovable'
import GroupSelectRemovableCheckbox from './_private/GroupSelectRemovableCheckbox'

/**
 * @displayName Group Select
 */
export default {
  name: 'ZGroupSelect',
  components: {
    GroupSelectCheckbox,
    GroupSelectRemovable,
    GroupSelectRemovableCheckbox,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    /**
     * Label do group select
     */
    label: {
      type: String,
      required: true,
    },
    /**
     * Altura do group select
     */
    height: {
      type: [Number, String],
      required: false,
      default: 60,
    },
    /**
     * Descrição para o item
     */
    description: {
      type: String,
      required: false,
      default: '',
    },
    /**
     * Valor para indicar se o select está ativo ou não
     *
     * @modelName value
     */
    value: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Flag para colocar o botão de delete
     */
    removable: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Flag para colocar o checkbox
     */
    checkbox: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Flag para colocar como outlined
     */
    outlined: {
      type: Boolean,
      required: false,
      default: false,
    },

    onIcon: {
      type: String,
      default: '$check_box_rounded',
    },

    offIcon: {
      type: String,
      default: '$check_box_outline_blank_rounded',
    },

    removeIcon: {
      type: String,
      default: '$remove_circle_outline_rounded',
    },
  },
  computed: {
    styleAttrs() {
      if (this.height) return {gridTemplateRows: this.height}
      return {}
    },
  },

  methods: {
    onChange(value) {
      /**
       * Emitido quando checkbox é clicado e altera seu valor
       *
       * @property {Boolean} value - Novo valor do checkbox
       */
      this.$emit('change', value)
    },
    onClickRemove(event) {
      /**
       * Emitido quando o botão de remover é clicado
       */
      this.$emit('click:remove', event)
    },
  },
}
</script>
